import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { useTranslation } from '@wix/cli-i18n';
import { writeCrashReport } from '@wix/cli-debug-log';
import { getDebugLogFilePath } from '@wix/cli-core-definitions';
import type { SelectOption } from '@wix/cli-ui-kit';
import { SelectInput, Spinner, useAsync } from '@wix/cli-ui-kit';
import { getDefaultBranch } from '../git/index.js';
import { DeploymentSource } from '../gridapp/deployApp.js';

interface SelectPreviewSourceProps {
  projectFolder: string;
  onSubmit: (option: SelectOption<DeploymentSource>) => void;
}

export const SelectPreviewSource: FC<SelectPreviewSourceProps> = ({
  projectFolder,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const { status } = useAsync(
    () =>
      getDefaultBranch((e) =>
        writeCrashReport(getDebugLogFilePath(projectFolder), e)
      ),
    []
  );

  return match(status, {
    Error: () => null,
    Loading: () => <Spinner />,
    Success: ({ result: defaultBranchName }) => (
      <SelectInput<DeploymentSource>
        label={t('preview_command.prompt_what_to_preview')}
        options={[
          {
            key: 'remote',
            value: DeploymentSource.remote(),
            title: defaultBranchName
              ? t('preview_command.prompt_what_to_preview_choice_latest', {
                  branchName: defaultBranchName,
                })
              : t(
                  'preview_command.prompt_what_to_preview_choice_latest_fallback'
                ),
          },
          {
            key: 'local',
            value: DeploymentSource.local(),
            title: t('preview_command.prompt_what_to_preview_choice_local'),
          },
        ]}
        onSubmit={onSubmit}
      />
    ),
  });
};
